
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2(058|44|471)|8(219|227|431|849)|7(193|414|850|92)|([45]31|472)3|1484|3181|5912|6610|9927)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
